<template>
  <div class="fluid-view-content-container">
    <european-union-component></european-union-component>
    <news-component
        @loading-finished="onComponentLoadingFinished('news')"
        id="news"
    ></news-component>
    <offer-component
        @loading-finished="onComponentLoadingFinished('offer')"
        id="offer"
        :colsTakenByTile="tileCols"
    ></offer-component>
    <management-component
        @loading-finished="onComponentLoadingFinished('company-management')"
        id="company-management"
        :colsTakenByTile="tileCols"
    ></management-component>
    <company-history-component
        @loading-finished="onComponentLoadingFinished('company-history')"
        id="company-history"
    ></company-history-component>
    <contact-component
        @loading-finished="onComponentLoadingFinished('contact')"
        id="contact"
    ></contact-component>
  </div>
</template>

<script>
import NewsComponent from "../components/NewsComponent/NewsComponent";
import OfferComponent from "../components/OfferTilesComponent/OfferTilesComponent";
import ManagementComponent from "../components/ManagementComponent";
import CompanyHistoryComponent from "../components/CompanyHistoryComponent/CompanyHistoryComponent";
import ContactComponent from "../components/ContactComponent/ContactComponent";
import EuropeanUnionComponent from "../components/EuropeanUnionComponent";

export default {
  name: "home",
  components: {
    EuropeanUnionComponent,
    NewsComponent,
    OfferComponent,
    ManagementComponent,
    CompanyHistoryComponent,
    ContactComponent
  },
  data: function () {
    return {
      loadingFinished: {
        news: false,
        offer: false,
        companyManagement: false,
        companyHistory: false,
        contact: false
      },
      currentThresholdPx: null,
      lastBreakpointName: null
    };
  },
  computed: {
    tileCols() {
      if (this.$vuetify.breakpoint.xs) {
        return 6;
      } else if (this.$vuetify.breakpoint.smAndUp && !this.$vuetify.breakpoint.lgAndUp) {
        return 4;
      } else if (this.$vuetify.breakpoint.lg) {
        return 3;
      } else if (this.$vuetify.breakpoint.xlOnly) {
        return 2;
      }
    }
  },
  created() {
    window.addEventListener("resize", this.onResize);
  },
  updated() {
    this.logOutIfTokenExpired();
  },
  watch: {
    $route(to) {
      this.scrollTo(to.name);
    }
  },
  methods: {
    onComponentLoadingFinished(componentName) {
      this.loadingFinished[componentName] = true;
      if (
          this.loadingFinished.news &&
          this.loadingFinished.offer &&
          this.loadingFinished.companyManagement &&
          this.loadingFinished.companyHistory &&
          this.loadingFinished.contact
      ) {
        this.scrollTo(componentName);
      }
    },
    logOutIfTokenExpired() {
      if (this.$store.state.authentication.tokenData.expiration) {
        let tokenExpiresAt = new Date(
            this.$store.state.authentication.tokenData.expiration
        );
        if (tokenExpiresAt.getTime() < new Date()) {
          this.$router.push("/admin");
        }
      }
    },
    scrollTo(componentName = this.$router.currentRoute.name) {
      if (this.$router.currentRoute.name === componentName) {
        this.$scrollTo(`#${this.$router.currentRoute.name}`, {offset: -64}); // v-app-bar has 64px
        this.autoscrollLaunched = true;
      }
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  }
};
</script>
